import request from "../utils/request";

/**
 * 某個人某一週「每天記了什麼」。
 *
 * 後端還在決定要擴充既有的 /Timesheet/Week 還是新開一支 /Timesheet/WeekLog，
 * 兩支的參數一模一樣（weekOffset / account），所以這裡兩支都留著，
 * 由 sagas/Timesheet.js 先打新的、404 再退回舊的那一支（理由寫在 saga 檔裡）。
 */
export function GET_TimesheetWeekLog(token, payload) {
  return request.get("/Timesheet/WeekLog", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/** 週工時表（舊端點；每日日誌若改成擴充這一支，回傳裡就會有 days 物件陣列） */
export function GET_TimesheetWeek(token, payload) {
  return request.get("/Timesheet/Week", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * 登記工時。
 *
 * /Timesheet 這一頁已經不填時數了（使用者：「時數沒屁用」），所以目前沒有畫面在呼叫它。
 * 仍然留著是因為後端 POST /Timesheet/Entry 還在、資料表 task_worklog 也還在被
 * 工項詳情的「已登記 N 小時」讀出來；哪天要把登記入口接回去（見個人工項那顆
 * 「去工時管理登記」）時，不必再重寫一次包裝。
 */
export function POST_TimesheetEntry(token, payload) {
  return request.post("/Timesheet/Entry", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}
